import { call, put, takeLatest } from "redux-saga/effects";
import {
  wholesalerReportByIdDateSearchFailure,
  wholesalerReportByIdDateSearchSuccess,
  wholesalerReportByIdFailure,
  wholesalerReportByIdSearchFailure,
  wholesalerReportByIdSearchSuccess,
  wholesalerReportByIdSuccess,
  wholesalerReportMonthByIdDateSearchFailure,
  wholesalerReportMonthByIdDateSearchSuccess,
  wholesalerReportMonthByIdFailure,
  wholesalerReportMonthByIdSuccess,
  wholesalerReportWeekByIdDateSearchRequest,
  wholesalerReportWeekByIdDateSearchSuccess,
  wholesalerReportWeekByIdFailure,
  wholesalerReportWeekByIdSuccess,
} from "./WholesalerReportByIdAction";
import {
  REPORT_WHOLESALER_MONTH_REPORT_BYID_REQUEST,
  REPORT_WHOLESALER_REPORT_BYID_REQUEST,
  REPORT_WHOLESALER_REPORT_BYID_SEARCH_REQUEST,
  REPORT_WHOLESALER_WEEK_REPORT_BYID_REQUEST,
  WHOLESALER_REPORT_BYID_DATE_SEARCH_REQUEST,
  WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_REQUEST,
  WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_REQUEST,
} from "./WholesalerReportByIdTypes";
import { WholesalerDayDateSearchReportByIdEffect, WholesalerDayReportByIdEffect, WholesalerMonthDateSearchReportByIdEffect, WholesalerMonthReportByIdEffect, WholesalerSearchReportByIdEffect, WholesalerWeekDateSearchReportByIdEffect, WholesalerWeekReportByIdEffect } from "./WholesalerReportByIdEffect.";

// Wholesaler Month Report By Id Saga
function* viewAllMonthWholesalerReportByIdSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const { wholesalerId, pageNo } = action.payload;
    const response = yield call(
      WholesalerMonthReportByIdEffect,
      wholesalerId,
      pageNo,
      config
    );

    yield put(wholesalerReportMonthByIdSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(wholesalerReportMonthByIdFailure({ errormessage: errorMessage }));
  }
}

// Wholesaler Week Report By Id Saga
function* viewAllWeekWholesalerReportByIdSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const { wholesalerId, pageNo } = action.payload;
    const response = yield call(
      WholesalerWeekReportByIdEffect,
      wholesalerId,
      pageNo,
      config
    );

    yield put(wholesalerReportWeekByIdSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(wholesalerReportWeekByIdFailure({ errormessage: errorMessage }));
  }
}

// Wholesaler Day Report By Id Saga
function* viewAllDayWholesalerReportByIdSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const { wholesalerId, pageNo } = action.payload;
    const response = yield call(
      WholesalerDayReportByIdEffect,
      wholesalerId,
      pageNo,
      config
    );

    yield put(wholesalerReportByIdSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(wholesalerReportByIdFailure({ errormessage: errorMessage }));
  }
}

// View All Month Search Wholesaler report By Id
function* viewAllMonthDateSearchWholesalerReportByIdSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const response = yield call(
      WholesalerMonthDateSearchReportByIdEffect,
      action.payload,
      config
    );

    yield put(wholesalerReportMonthByIdDateSearchSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(
      wholesalerReportMonthByIdDateSearchFailure({ errormessage: errorMessage })
    );
  }
}

// View All Week Search Wholesaler report By Id
function* viewAllWeekDateSearchWholesalerReportByIdSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const response = yield call(
      WholesalerWeekDateSearchReportByIdEffect,
      action.payload,
      config
    );

    yield put(wholesalerReportWeekByIdDateSearchSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(
        wholesalerReportWeekByIdDateSearchRequest,({ errormessage: errorMessage })
    );
  }
}

// View All Day Search Wholesaler report By Id
function* viewAllDateSearchWholesalerReportByIdSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const response = yield call(
      WholesalerDayDateSearchReportByIdEffect,
      action.payload,
      config
    );

    yield put(wholesalerReportByIdDateSearchSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(
      wholesalerReportByIdDateSearchFailure({ errormessage: errorMessage })
    );
  }
}

// View All Search Wholesaler report By Id
function* viewAllSearchWholesalerReportByIdSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const response = yield call(
      WholesalerSearchReportByIdEffect,
      action.payload,
      config
    );

    yield put(wholesalerReportByIdSearchSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(
      wholesalerReportByIdSearchFailure({ errormessage: errorMessage })
    );
  }
}

export function* WholesalerReportByIdSaga() {
  yield takeLatest(
    REPORT_WHOLESALER_MONTH_REPORT_BYID_REQUEST,
    viewAllMonthWholesalerReportByIdSaga
  );
  yield takeLatest(
    REPORT_WHOLESALER_WEEK_REPORT_BYID_REQUEST,
    viewAllWeekWholesalerReportByIdSaga
  );
  yield takeLatest(
    REPORT_WHOLESALER_REPORT_BYID_REQUEST,
    viewAllDayWholesalerReportByIdSaga
  );
  yield takeLatest(
    WHOLESALER_REPORT_MONTH_BYID_DATE_SEARCH_REQUEST,
    viewAllMonthDateSearchWholesalerReportByIdSaga
  );
  yield takeLatest(
    WHOLESALER_REPORT_WEEK_BYID_DATE_SEARCH_REQUEST,
    viewAllWeekDateSearchWholesalerReportByIdSaga
  );
  yield takeLatest(
    REPORT_WHOLESALER_REPORT_BYID_SEARCH_REQUEST,
    viewAllSearchWholesalerReportByIdSaga
  );
  yield takeLatest(
    WHOLESALER_REPORT_BYID_DATE_SEARCH_REQUEST,
    viewAllDateSearchWholesalerReportByIdSaga
  );
}
